import script from "./ClientsScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsScroll.vue?vue&type=script&setup=true&lang=js"

import "./ClientsScroll.vue?vue&type=style&index=0&id=7b2e8788&lang=scss"

const __exports__ = script;

export default __exports__